import { Head } from '@inertiajs/react'

// Self-contained chrome for the public legal pages (no authenticated app shell).
// Child variant classes style the plain semantic markup the pages pass in, so
// Privacy/Tos stay readable prose without per-element Tailwind classes.
export default function LegalDocument({
  title,
  lastUpdated,
  contactEmail,
  children,
}: {
  title: string
  lastUpdated: string
  contactEmail: string
  children: React.ReactNode
}) {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-900">
      <Head title={`${title} — Nereus`} />

      <header className="border-b bg-white">
        <div className="mx-auto flex h-14 max-w-3xl items-center justify-between px-6">
          <a href="/" className="flex items-center gap-2 text-sm font-semibold tracking-tight">
            <img src="/nereus-logo.svg" alt="" className="h-6 w-6 rounded" />
            Nereus
          </a>
          <nav className="flex items-center gap-4 text-[13px] text-gray-500">
            <a href="/privacy" className="hover:text-gray-900">Privacy</a>
            <a href="/tos" className="hover:text-gray-900">Terms</a>
          </nav>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-12">
        <h1 className="text-2xl font-bold tracking-tight sm:text-3xl">{title}</h1>
        <p className="mt-2 text-sm text-gray-500">Last updated: {lastUpdated}</p>

        <article
          className="mt-8 text-[15px] leading-7 text-gray-700
            [&_a]:text-blue-600 [&_a]:underline
            [&_h2]:mt-10 [&_h2]:mb-3 [&_h2]:text-lg [&_h2]:font-semibold [&_h2]:text-gray-900
            [&_h3]:mt-6 [&_h3]:mb-2 [&_h3]:text-[15px] [&_h3]:font-semibold [&_h3]:text-gray-900
            [&_p]:mb-4
            [&_ul]:mb-4 [&_ul]:list-disc [&_ul]:space-y-1.5 [&_ul]:pl-6"
        >
          {children}
        </article>

        <footer className="mt-12 border-t pt-6 text-sm text-gray-500">
          <p>
            Questions? Email{' '}
            <a href={`mailto:${contactEmail}`} className="text-blue-600 underline">{contactEmail}</a>.
          </p>
          <p className="mt-2">
            <a href="/privacy" className="text-blue-600 underline">Privacy Policy</a>
            {' · '}
            <a href="/tos" className="text-blue-600 underline">Terms of Service</a>
          </p>
        </footer>
      </main>
    </div>
  )
}
